module.exports = __webpack_public_path__ + "img/3rd.37cfa257.png";